"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const chart_type_model_1 = require("../../../../controls/chart/shared/chart-type.model");
const idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
const core_1 = require("@angular/core");
const Subject_1 = require("rxjs/Subject");
/**
 * Created by mariam.melkonyan on 8/30/17.
 */
let CategoricalChartOptions = class CategoricalChartOptions {
    constructor() {
        this._isMeasureAxisZoomSlicerVisible = false;
        this._isCategoryAxisZoomSlicerVisible = false;
        /**
         * Subject for emitting chart options changes.
         * @type {Subject<void>}
         */
        this._chartOptionsSubject = new Subject_1.Subject();
        this._valueAxisTitle = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map());
        this._categoryAxisTitle = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map());
    }
    set chartType(chartType) {
        this._chartType = chartType;
        if (chartType !== chart_type_model_1.ChartType.BAR && chartType !== chart_type_model_1.ChartType.COLUMN) {
            this._isStackedChart = false;
            this._isStackedChartByPercent = false;
        }
        this._chartOptionsSubject.next();
    }
    get chartType() {
        return this._chartType;
    }
    set categoryAxisTitle(categoryAxisTitle) {
        this._categoryAxisTitle = categoryAxisTitle;
        this._chartOptionsSubject.next();
    }
    get categoryAxisTitle() {
        return this._categoryAxisTitle;
    }
    set valueAxisTitle(valueAxisTitle) {
        this._valueAxisTitle = valueAxisTitle;
        this._chartOptionsSubject.next();
    }
    get valueAxisTitle() {
        return this._valueAxisTitle;
    }
    set isStackedChart(isStackedChart) {
        this._isStackedChart = isStackedChart;
        !isStackedChart && (this._isStackedChartByPercent = false);
        this._chartOptionsSubject.next();
    }
    get isStackedChart() {
        return this._isStackedChart;
    }
    set isStackedChartByPercent(isStackedChartByPercent) {
        this._isStackedChartByPercent = isStackedChartByPercent;
        this._chartOptionsSubject.next();
    }
    get isStackedChartByPercent() {
        return this._isStackedChartByPercent;
    }
    set selectedPaletteId(selectedPaletteId) {
        this._selectedPaletteId = selectedPaletteId;
        this._chartOptionsSubject.next();
    }
    get selectedPaletteId() {
        return this._selectedPaletteId;
    }
    get isDataLabelsShowed() {
        return this._isDataLabelsShowed;
    }
    set isDataLabelsShowed(value) {
        this._isDataLabelsShowed = value;
        this._chartOptionsSubject.next();
    }
    get isMeasureAxisZoomSlicerVisible() {
        return this._isMeasureAxisZoomSlicerVisible;
    }
    set isMeasureAxisZoomSlicerVisible(value) {
        this._isMeasureAxisZoomSlicerVisible = value;
        this._chartOptionsSubject.next();
    }
    get isCategoryAxisZoomSlicerVisible() {
        return this._isCategoryAxisZoomSlicerVisible;
    }
    set isCategoryAxisZoomSlicerVisible(value) {
        this._isCategoryAxisZoomSlicerVisible = value;
        this._chartOptionsSubject.next();
    }
    deserialize(jsonObject, languages) {
        this._chartType = jsonObject.chartType;
        this._selectedPaletteId = jsonObject.selectedPaletteId;
        this._valueAxisTitle = this.deserializeMultilingualString(jsonObject.valueAxisTitle, languages);
        this._categoryAxisTitle = this.deserializeMultilingualString(jsonObject.categoryAxisTitle, languages);
        this._isStackedChart = jsonObject.isStackedChart;
        this._isStackedChartByPercent = jsonObject.isStackedChartByPercent;
        this._isDataLabelsShowed = jsonObject.isDataLabelsShowed;
        this._isMeasureAxisZoomSlicerVisible = jsonObject.isMeasureAxisZoomSlicerVisible;
        this._isCategoryAxisZoomSlicerVisible = jsonObject.isCategoryAxisZoomSlicerVisible;
    }
    serialize(languages) {
        let jsonObject = {};
        jsonObject.chartType = this.chartType;
        jsonObject.selectedPaletteId = this.selectedPaletteId;
        jsonObject.valueAxisTitle = this.serializeMultilingualString(this.valueAxisTitle, languages);
        jsonObject.categoryAxisTitle = this.serializeMultilingualString(this.categoryAxisTitle, languages);
        jsonObject.isStackedChart = this.isStackedChart;
        jsonObject.isStackedChartByPercent = this.isStackedChartByPercent;
        jsonObject.isDataLabelsShowed = this.isDataLabelsShowed;
        jsonObject.isMeasureAxisZoomSlicerVisible = this.isMeasureAxisZoomSlicerVisible;
        jsonObject.isCategoryAxisZoomSlicerVisible = this.isCategoryAxisZoomSlicerVisible;
        return jsonObject;
    }
    deserializeMultilingualString(jsonObject, languages) {
        let multilingualStringBuilder = new idm_crosscutting_concepts_frontend_1.MultilingualStringBuilder();
        languages.forEach((language) => {
            let languageId = language.getId();
            multilingualStringBuilder.withValueForLanguage(languageId, jsonObject[languageId] || null);
        });
        return multilingualStringBuilder.build();
    }
    serializeMultilingualString(multilingualString, languages) {
        let jsonObject = {};
        languages.forEach((language) => {
            let languageId = language.getId();
            jsonObject[languageId] = multilingualString.getValue(languageId);
        });
        return jsonObject;
    }
    /**
     * Returns an observale that emits every time the report model is changed.
     * @returns {Subject<void>}
     */
    getCategoricalChartOptions() {
        return this._chartOptionsSubject;
    }
};
CategoricalChartOptions = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], CategoricalChartOptions);
exports.CategoricalChartOptions = CategoricalChartOptions;
//# sourceMappingURL=categorical-chart-options.model.js.map